import { type MoveEvent, TYPE_MASK, pieceDef } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const UP = '/art/levelup.svg';
const leveled = (e: MoveEvent) => e.t === 'add' && e.cause === 'level-up';

export const levelupUi: VariantUi = {
  heroImage: UP,
  peek: [{}, { image: '/art/wB.svg' }, {}, {}, { image: UP, threat: true }, {}, {}, { image: '/art/wN.svg' }, {}],

  twist() {
    return { text: 'Capture to level up: pawn → knight → bishop → rook → queen' };
  },

  eventSound(e) {
    return leveled(e) ? 'levelup' : null;
  },

  moveBadge(rec) {
    const e = rec.events.find(leveled);
    return e && e.t === 'add' ? { icon: UP, victim: e.piece, title: `Leveled up to a ${pieceDef(e.piece & TYPE_MASK).name}` } : null;
  },
};
